import { render, staticRenderFns } from "./404.vue?vue&type=template&id=450d2710&scoped=true&"
import script from "./404.vue?vue&type=script&lang=babel&"
export * from "./404.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450d2710",
  null
  
)

export default component.exports